import {
  ACCESS_TOKEN_STORAGE_KEY,
  CURRENT_PROJECT_UUID_STORAGE_KEY,
  LANGUAGE_STORAGE_KEY,
  SAML_ORGANIZATION_UUID_STORAGE_KEY,
} from "@frontend-shared/constants";

import { FLAVOR_CONFIG } from "@/lib/flavor-config";

export const getToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
};

export const setToken = (token: string): void => {
  localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, token);
};

export const removeToken = (): void => {
  localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
};

// NOTE: NSAI-7394 — the active project belongs to the TAB, not to the browser.
// Every project-scoped request (the X-Project-Uuid header, the chat and help
// websockets) reads it from here, and localStorage is shared by every tab of
// the origin: with the personal project open in one tab and an organization
// project in another, whichever tab switched last redirected the other tab's
// writes into its project while that tab's UI still showed its own.
// sessionStorage is per tab and survives a reload of that tab. localStorage is
// still written, but only as the seed a tab that has not picked a project yet
// starts from — so a new tab opens on the last-used project.
//
// HACK: the seed is pinned into the tab on the first read. A tab that never
// switches never writes its own pointer, so without the pin it would keep
// following the shared seed — and with it, every other tab's switches.
export const getProjectUuid = (): string | null => {
  const tabProjectUuid = sessionStorage.getItem(
    CURRENT_PROJECT_UUID_STORAGE_KEY,
  );

  if (tabProjectUuid !== null) {
    return tabProjectUuid;
  }

  const seedProjectUuid = localStorage.getItem(
    CURRENT_PROJECT_UUID_STORAGE_KEY,
  );

  if (seedProjectUuid) {
    sessionStorage.setItem(CURRENT_PROJECT_UUID_STORAGE_KEY, seedProjectUuid);
  }

  return seedProjectUuid;
};

export const setProjectUuid = (projectUuid: string): void => {
  sessionStorage.setItem(CURRENT_PROJECT_UUID_STORAGE_KEY, projectUuid);
  localStorage.setItem(CURRENT_PROJECT_UUID_STORAGE_KEY, projectUuid);
};

// NOTE: Clears this tab's pointer only. The shared seed is cleared with the
// rest of the session in clearLocalStorage.
export const removeTabProjectUuid = (): void => {
  sessionStorage.removeItem(CURRENT_PROJECT_UUID_STORAGE_KEY);
};

export const getLanguage = (): string | null => {
  return (
    localStorage.getItem(LANGUAGE_STORAGE_KEY) || FLAVOR_CONFIG.defaultLanguage
  );
};

export const getSamlOrganizationUuid = (): string | null => {
  return localStorage.getItem(SAML_ORGANIZATION_UUID_STORAGE_KEY);
};
